module.exports = __webpack_public_path__ + "static/media/Initial Class Minds.f4ce0d7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/Initial Class Minds.pdf
// module id = 899
// module chunks = 2 7 38